function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocYtW = function SvgSocYtW(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 37 26"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.24 18.06V7.93L24 13Zm22.68-8.13c-.24-6.12-1.12-7-1.12-7C33.93-.19 27.87 0 27.87 0H9.1S3-.19 1.16 2.94c0 0-.87.87-1.11 7v6.25c.32 6.12 1.21 7 1.21 7 1.9 3.11 8 2.84 8 2.84h18.53s6.06.27 8-2.84c0 0 .89-.85 1.2-7Z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgSocYtW;